import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth-guard';

export const routes: Routes = [
    // 🔹 Public Layout (no auth guard)
    {
        path: '',
        loadComponent: () =>
            import('./layout/public-layout/public-layout').then(m => m.PublicLayout),
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            {
                path: 'home',
                loadComponent: () =>
                    import('./features/public/home/home').then(m => m.Home),
            },
            {
                path: 'about',
                loadComponent: () =>
                    import('./features/public/about/about').then(m => m.About),
            },
            {
                path: 'temples',
                loadComponent: () => import('./features/public/temples/temples').then(m => m.Temples)
            },
            {
                path: 'search',
                loadComponent: () => import('./features/public/search-page/search-page').then(m => m.SearchPage)
            },
            // {
            //     path: 'membership',
            //     loadComponent: () => import('./features/public/membership/membership').then(m => m.Membership)
            // }

            // you can add more like contact, terms, etc.
        ]
    },

    // 🔹 Auth layout (login/register/forgot)
    {
        path: '',
        loadComponent: () =>
            import('./layout/login-layout/login-layout').then(m => m.LoginLayout),
        children: [
            { path: 'login', loadComponent: () => import('./auth/login/login').then(m => m.Login) },
            { path: 'register', loadComponent: () => import('./auth/register/register').then(m => m.Register) },
            { path: 'forgot', loadComponent: () => import('./auth/forgot/forgot').then(m => m.Forgot) }
        ]
    },

    // 🔹 Main app (protected)
    {
        path: '',
        loadComponent: () =>
            import('./layout/layout/layout').then(m => m.Layout),
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: 'dashboard',
                loadComponent: () =>
                    import('./features/dashboard/dashboard').then(m => m.Dashboard),
            },
            {
                path: 'master',
                loadChildren: () =>
                    import('./features/masters/master.routes').then(m => m.MASTER_ROUTES),
            },
            {
                path: 'department',
                loadComponent: () =>
                    import('./features/department/department-list/department-list').then(m => m.DepartmentList),
            },
        ]
    },

    // 🔹 Fallback
    { path: '**', redirectTo: 'home' }
];
